/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import luiIconLoader from './lui-icon-loader'

class LuiIconPathLoader {
  constructor(path) {
    this._path = path
  }

  getIcon(iconName) {
    const svg = this._loadSvg(iconName)
    return svg
  }

  _loadSvg(iconName) {
    return luiIconLoader.loadSvg(`${this._path}/${iconName}.svg`)
  }
}

export default LuiIconPathLoader
window.lui.LuiIconPathLoader = LuiIconPathLoader



//////////////////
// WEBPACK FOOTER
// ./packages/lui-icon/loader/lui-icon-path-loader.js
// module id = 218
// module chunks = 0 1 12